import React, { useEffect } from "react";
import { formatDate, formatDateDDMMYYYY, formatDateDDMMYYYYHHMMSS } from "../../Utils/data&dateTime";
import collegeLogo from "../../assets/Images/college-logo.png";
import '../../assets/css/Modal.css'
import '../../assets/css/StudentShortDetails.css'
import Notifier from "../../Utils/notify";
import directorSign from '../../assets/Images/Dir_signatures.jpeg'
import { formatCourseListWithRoman, formatCourseListWithRomanString } from "../../Utils/ConvertRoman";

const FeeNoticeCourseWise = ({ course, isOpen, onClose, noticeData, students }) => {

    // console.log("noticeData", noticeData)
    // console.log("STUDENTS", students)


    // ✅ unify student/fee list depending on which prop is passed
    const feeList = noticeData?.feeDetails || students || [];

    const pendingCount = feeList?.length || 0;

    const handleShare = async () => {
        let message = "";

        if (noticeData && feeList?.length > 0) {
            // ✅ Extract and clean unique course names
            const uniqueCourses = [
                ...new Set(
                    feeList.map((f) =>
                        f.course_name?.replace(/\s*SECTION\s*[A-Z]+/gi, "")?.trim()
                    )
                ),
            ].filter(Boolean);

            // ✅ Convert to Roman
            const romanCoursesString = formatCourseListWithRoman(uniqueCourses);

            // ✅ Split for “A, B and C” formatting
            const romanCourses = romanCoursesString.split(" , ");
            const formattedCourses =
                romanCourses.length > 1
                    ? `${romanCourses.slice(0, -1).join(", ")} and ${romanCourses.slice(-1)}`
                    : romanCourses[0];

            const dueDate = new Date(
                noticeData?.pendingPayload?.due_date || feeList[0]?.due_date
            ).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
            });

            const perDay = noticeData?.pendingPayload?.penalty_per_day || 0;
            const max = noticeData?.pendingPayload?.max_penalty || 0;

            message = `📢 *Fee Notice*
            ----------------------------------
            Institution: Banaras Institute of Teacher's Education, Varanasi
            Affiliated with Mahatma Gandhi Kashi Vidyapith

            Date: ${formatDateDDMMYYYYHHMMSS(noticeData?.createdDate)}
            Document No: ${noticeData?.uniqueId || "-"}

           This is to inform all students of *${formattedCourses}* that they must deposit their pending fees by *${dueDate}*.
            `;

            if (perDay > 0 || max > 0) {
                message += `
            Important:
                • Delay in payment will attract a penalty of ₹${perDay}/day ${max > 0 ? `(Max ₹${max})` : ""}
                • Students are advised to pay within the stipulated time to avoid penalties.
                `;
            }

            message += `
                Director
                (Banaras Institute of Teacher's Education, Varanasi)
                ----------------------------------`;

            if (noticeData?.copy_to_details?.length > 0) {
                message += `\n\nCopy to:\n${noticeData.copy_to_details
                    .map(
                        (c, i) =>
                            `${i + 1}. ${c.designation}${c.reason ? ` (${c.reason})` : ""}`
                    )
                    .join("\n")}`;
            }
        }
        else if (students) {
            const courseList = Array.from(students?.course_names || []);
            // ✅ Convert to Roman form
            const courseNames = formatCourseListWithRoman(courseList);

            const dueDate = students?.due_date ? formatDate(new Date(students.due_date)) : "-";

            const perDay = students?.penalty_per_day || 0;
            const max = students?.max_penalty || 0;

            message = `📢 *Fee Notice*
                ----------------------------------
                Institution: Banaras Institute of Teacher's Education
                Affiliated with Mahatma Gandhi Kashi Vidyapith

                Ref No: ${students?.document_number && students.document_number !== "-"
                    ? students.document_number
                    : students?.id || "N/A"
                }
                Date: ${students?.created_at
                    ? formatDateDDMMYYYYHHMMSS(students.created_at)
                    : "N/A"
                }

                This is to inform all students of *${courseNames}* that they must deposit their pending fees by *${dueDate}*.
                `;

            if (perDay > 0 || max > 0) {
                message += `
                Important:
                • Delay in payment will attract a penalty of ₹${perDay}/day ${max > 0 ? `(Max ₹${max})` : ""}
                • Students are advised to pay the fee within the stipulated time to avoid penalties.
                `;
            }

            message += `
                Director
                
                ----------------------------------`;

            if (students?.copied_to?.length > 0) {
                message += `\n\nCopy to:\n${students.copied_to
                    .map(
                        (c, i) =>
                            `${i + 1}. ${c.designation_id}${c.reason ? ` (${c.reason})` : ""}`
                    )
                    .join("\n")}`;
            }
        }
        else {
            message = "No fee notice data available.";
        }

        // ✅ Try native share
        if (navigator.share) {
            try {
                await navigator.share({
                    title: "Fee Notice",
                    text: message,
                });
                return;
            } catch (err) {
                console.warn("Share canceled or failed:", err);
            }
        }

        // ✅ Fallback to WhatsApp copy
        navigator.clipboard.writeText(message).then(() => {
            Notifier.info("Notice details copied to clipboard!");
            const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
            window.open(whatsappUrl, "_blank");
        });
    };




    const handlePrintNotice = () => {
        const printContent = document.getElementById("print-wrapper");
        if (!printContent) return;

        const newWindow = window.open("width=800,height=1100");

        newWindow.document.write(`
    <html>
      <head>
        <title>Fee Notice</title>
        <style>
         
                    body {
             
                     font-family: "Poppins", "Roboto", sans-serif;
                    padding: 40px 0;
                    color: #000000;
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                    background: #ffffff;
                    }

                    .print-container {
                        width: 700px;
                        margin: 0 auto;
                    }
                    .notice-page {
                        page-break-after: always;
                        border: none !important;
                        padding: 20px;
                        margin-bottom: 20px;
                    }
                        .due-date{
                    font-weight: bold
                    }
                    .print-header{
                    margin-bottom: 50px;}

                .notice-date{margin-top:10px !important; margin-bottom:0px  !important}
                h5, h6 { text-align: center; }
                .text-center { text-align: center; }
                .collegenameTitle { font-size: 20px; font-weight: bold;margin-top:0px !important; margin-bottom:0px  !important}
                .affiliateTitle { font-size: 16px !important; font-weight: 500; margin-top: 0px !important;
                margin-bottom:8px !important }
                strong { font-weight: bold; font-size: 16px }
                .approvals { font-size: 17px !important;  }
                .noticedetails{font-size:18px !important; }
                .signatures-block li{font-size:18px !important; }
                .signatures-block strong{font-size:18px !important; }
                .noticedetails p { margin: 2px 0; font-size: 24px;font-weight: 600 }
                .documentnumber{margin-top:0px !important; margin-bottom:10px  !important}
                .delay{margin-top:0px !important; margin-bottom:2px  !important; font-weight: 400 !important;font-size: 18px !important }
                .importanrtP{ margin-bottom:2px  !important}
                .Babatpur{margin-top:unset !important; }
                            .notice-date {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;
            width: 100%;
            }

            .notice-date p {
            margin: 0;
            font-size: 14px;
            font-weight: 600;
            color: black;
            }

            .notice-date strong span {
            font-weight: 400;
            }

            </style>
        </head>
        <body>
        <div class="print-container">
          ${printContent.innerHTML}
        </div>
      </body>
    </html>
  `);

        newWindow.document.close();
        // ✅ Fix: Wait for image load before printing
        newWindow.onload = () => {
            const logoImg = newWindow.document.getElementById("collegeLogo");

            if (logoImg && !logoImg.complete) {
                logoImg.onload = () => {
                    newWindow.focus();
                    newWindow.print();
                    newWindow.close();
                };
            } else {
                newWindow.focus();
                newWindow.print();
                newWindow.close();
            }
        };

        // 🔑 Close modal in parent page so it doesn't show in background
        if (typeof onClose === "function") {
            onClose();
        }
    };



    if (!isOpen) return null;


    return (
        <div id="print-wrap" style={{ width: "100%", overflowX: "auto", padding: "20px" }} className="feenotice-print-wrap">
            <div className="modal-overlay view-feenotice-print-modal feenotice-overlay">
                <div className="print-areass feenotice-print-area">
                    <div

                        className="modal-content scheduleformprint feenotice-container mt-1"
                        style={{
                            maxHeight: "80vh",
                            overflowY: "auto",
                            padding: "20px",
                            backgroundColor: "white",
                            boxSizing: 'border-box',
                            borderRadius: "8px",
                            width: "90%",
                            margin: "auto",
                            position: "relative",
                        }}
                    >
                        <div className="modal-title d-flex justify-content-end align-items-center">
                            <button
                                className="close-btn no-print"
                                onClick={onClose}
                                aria-label="Close"
                                style={{
                                    color: "black",
                                    border: "none",
                                    background: "transparent",
                                    fontSize: "18px",
                                }}
                            >
                                ✖
                            </button>
                        </div>
                        <div id="print-wrapper" className="notice-page feenotice-page" style={{ border: '1px solid', padding: '20px' }}>


                            <div className="print-header">
                                <div className="text-center imageLogoCollege">
                                    <img src={collegeLogo} id="collegeLogo" width={120} height={120} />
                                </div>

                                <h5 style={{ fontWeight: "bold", color: "black", textAlign: "center" }} className="collegenameTitle mt-2">
                                    Banaras Institute of Teacher's Education
                                </h5>
                                <p
                                    style={{
                                        fontStyle: "italic",
                                        textAlign: "center",
                                        color: "black",
                                        fontWeight: "500",
                                        fontSize: "14px",
                                    }}
                                    className="mt-3 affiliateTitle"
                                >
                                    (Affiliated with Mahatma Gandhi Kashi Vidyapith, Varanasi)
                                </p>

                                <p className="mb-5 Babatpur" style={{ fontWeight: "bold", textAlign: "center" }}>Babatpur, Varanasi</p>


                            </div>




                            {/* Notice Details (only if noticeData present) */}
                            {noticeData && (
                                <div className="notice-date d-flex justify-content-between">
                                    <p className="noticedetails documentnumber">
                                        <strong style={{ fontSize: "14px", fontWeight: "600" }}>
                                            Ref No: <span style={{ fontWeight: "400" }}>{noticeData?.uniqueId}</span>
                                        </strong>
                                    </p>
                                    <p className="noticedetails">
                                        <strong style={{ fontSize: "14px", fontWeight: "600", color: "black" }}>
                                            Date:{" "}
                                            <span style={{ fontWeight: "400" }}>
                                                {formatDateDDMMYYYYHHMMSS(noticeData?.createdDate)}
                                            </span>
                                        </strong>
                                    </p>

                                </div>
                            )}

                            {students && (
                                <div className="notice-date" style={{ display: "flex", gap: "20px", justifyContent: 'space-between' }}>
                                    <p className="noticedetails documentnumber" style={{ margin: 0 }}>
                                        <strong style={{ fontSize: "14px", fontWeight: "600" }}>
                                            Ref No.:{" "}
                                            <span style={{ fontWeight: "400" }}>
                                                {students?.document_number}
                                            </span>
                                        </strong>
                                    </p>
                                    <p className="noticedetails" style={{ margin: 0 }}>
                                        <strong style={{ fontSize: "14px", fontWeight: "600", color: "black" }}>
                                            Date:{" "}
                                            <span style={{ fontWeight: "400" }}>
                                                {students?.created_at ? formatDateDDMMYYYYHHMMSS(students.created_at) : "N/A"}
                                            </span>
                                        </strong>
                                    </p>

                                </div>
                            )}
                            <p className="mb-5 mt-1" style={{ fontWeight: "bold", textAlign: "center", textDecoration: 'underline', fontSize: '20px' }}>Important Notice</p>
                            {/* Notice Message */}

                            {noticeData && (() => {
                                // ✅ Prefer feeDetails from noticeData
                                const feeList = noticeData?.feeDetails || [];

                                // ✅ Extract unique course names (remove “SECTION A/B/C”)
                                const uniqueCourses = [
                                    ...new Set(
                                        feeList.map((f) =>
                                            f.course_name
                                                ?.replace(/\s*SECTION\s*[A-Z]+/gi, "") // remove section part
                                                ?.trim()
                                        )
                                    ),
                                ].filter(Boolean);

                                // ✅ Convert to Roman form (e.g., "Semester 3" → "Semester III")
                                const romanCoursesString = formatCourseListWithRoman(uniqueCourses);

                                // ✅ Split back into array for "A, B, and C" formatting
                                const romanCourses = romanCoursesString.split(" , ");
                                const formattedCourses =
                                    romanCourses.length > 1
                                        ? `${romanCourses.slice(0, -1).join(", ")} and ${romanCourses.slice(-1)}`
                                        : romanCourses[0];

                                // ✅ Format due date (e.g., "31st Oct 2025")
                                const rawDate = new Date(
                                    noticeData?.pendingPayload?.due_date || feeList[0]?.due_date
                                );
                                const dueDate = formatDate(rawDate);

                                return (
                                    <div className="noticedetails mt-3" style={{ color: "black" }}>
                                        This is to inform all students of {" "}
                                        <strong>{formattedCourses}</strong> that they must deposit their pending fees by<strong>{dueDate}</strong>.
                                    </div>
                                );
                            })()}

                            {students && (() => {
                                const courseList = students.full_course_name;

                                const courseNames = formatCourseListWithRomanString(courseList)


                                const dueDate = students?.due_date
                                    ? formatDate(new Date(students.due_date))
                                    : "-";

                                return (
                                    <div
                                        className="noticedetails mt-3"
                                        style={{ color: "black", whiteSpace: "pre-line" }}
                                    >
                                        This is to inform all students of {" "}
                                        <strong>{courseNames}</strong> that they must deposit their pending fees by {" "}
                                        <strong>{dueDate}</strong>.
                                    </div>
                                );
                            })()}



                            {noticeData && noticeData?.pendingPayload?.penalty_per_day > 0 && (
                                <div className="d-flex gap-3">
                                    <div className="noticedetails">
                                        <p className="mt-2 importanrtP">
                                            <strong>Important:</strong>
                                        </p>
                                        <br />
                                        <p style={{ marginLeft: "20px" }} className="delay">
                                            • Delay in payment will attract a{" "}
                                            <strong className="due-date">
                                                penalty of ₹ {noticeData.pendingPayload.penalty_per_day}
                                            </strong>{" "}
                                            per day, subject to a maximum of{" "}
                                            <strong className="due-date">
                                                ₹ {noticeData.pendingPayload.max_penalty}.
                                            </strong>
                                        </p>
                                        <p style={{ marginLeft: "20px" }} className="delay">
                                            • Students are advised to pay the fee within the stipulated time to
                                            avoid <strong className="due-date">penalties.</strong>
                                        </p>
                                    </div>
                                </div>
                            )}


                            {students && students?.penalty_per_day > 0 && (
                                <div className="d-flex gap-3">
                                    <div className="noticedetails">
                                        <p className="mt-2 importanrtP">
                                            <strong>Important:</strong>
                                        </p>
                                        <br />
                                        {students?.penalty_per_day > 0 && (
                                            <p style={{ marginLeft: "20px" }} className="delay">
                                                • Delay in payment will attract a penalty of{" "}
                                                <strong className="due-date">₹ {students.penalty_per_day}</strong> per day,
                                                subject to a maximum of{" "}
                                                <strong className="due-date">₹ {students.max_penalty}</strong>.
                                            </p>
                                        )}

                                        <p style={{ marginLeft: "20px" }} className="delay">
                                            • Students are advised to pay the fee within the stipulated time to avoid{" "}
                                            <strong className="due-date"> penalties.</strong>
                                        </p>
                                    </div>
                                </div>
                            )}


                            <div
                                className="signatures-block"
                                style={{
                                    marginTop: "20px",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    gap: "40px", // spacing between the two rows
                                }}
                            >
                                {/* Row 1: Director (Right Aligned) */}

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        width: "100%", // ensure full width
                                    }}
                                >
                                    <div
                                        style={{
                                            textAlign: "right",
                                            width: "fit-content", // prevent shrinking
                                        }}
                                    >
                                        <img
                                            src={directorSign}
                                            alt="Director's Signature"
                                            style={{
                                                width: "180px",
                                                height: "auto",
                                                display: "block",
                                                marginLeft: "auto", // ensures image pushes right inside container
                                            }}
                                        />
                                        <div className="approvals" style={{ fontWeight: "bold", textAlign: "center" }}>
                                            Director
                                        </div>
                                    </div>
                                </div>


                                {/* Row 2: Copy To (Left Aligned) */}
                                {students?.copied_to?.length > 0 && (
                                    <div style={{ display: "flex", justifyContent: "flex-start" }}>
                                        <div style={{ textAlign: "left" }}>
                                            <strong style={{ display: "block", marginBottom: "6px" }}>Copy to:</strong>
                                            <ol
                                                style={{
                                                    margin: 0,
                                                    paddingLeft: "20px",
                                                    lineHeight: "1.6",
                                                    fontSize: "14px",
                                                }}
                                            >
                                                {students.copied_to.map((item, idx) => (
                                                    <li key={idx}>
                                                        {item.designation_id}
                                                        {item.reason ? ` (${item.reason})` : ""}
                                                    </li>
                                                ))}
                                            </ol>
                                        </div>
                                    </div>
                                )}

                                {noticeData?.copy_to_details?.length > 0 && (
                                    <div style={{ display: "flex", justifyContent: "flex-start" }}>
                                        <div style={{ textAlign: "left" }}>
                                            <strong style={{ display: "block", marginBottom: "6px" }}>Copy to:</strong>
                                            <ol
                                                style={{
                                                    margin: 0,
                                                    paddingLeft: "20px",
                                                    lineHeight: "1.6",
                                                    fontSize: "14px",
                                                }}
                                            >
                                                {noticeData.copy_to_details.map((item, idx) => (
                                                    <li key={idx}>
                                                        {item.designation}
                                                        {item.reason ? ` (${item.reason})` : ""}
                                                    </li>
                                                ))}
                                            </ol>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div style={{ marginTop: "40px", textAlign: "end" }} className="d-flex justify-content-end gap-2">
                            <button
                                onClick={handleShare}
                                className="btn btn-success no-print"
                                style={{ padding: "8px 20px", fontSize: "16px", cursor: "pointer" }}
                            >
                                Share
                            </button>
                            <button
                                onClick={handlePrintNotice}
                                className="add-btn no-print"
                                style={{ padding: "8px 20px", fontSize: "16px", cursor: "pointer" }}
                            >
                                Print
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default FeeNoticeCourseWise;
